export default "__VITE_ASSET__CU4AbM$F__"